import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";
import ContactUs from "../../Components/ContactUs/index";
import Body7 from "../../Components/Home-new/Body7";
import Body9 from "../../Components/Home-new/Body9";
import { ContactDataProvider, useContactData } from "../../database/ContactDataContext";
import { ContactUsSkeleton, Body7Skeleton, Body9Skeleton } from "../../Components/Skeletons/Skeletons";

const ContactPageContent = () => {
    const { data, isLoading } = useContactData();

    if (isLoading) {
        return (
            <>
                <ContactUsSkeleton />
                <Body7Skeleton />
                <Body9Skeleton />
            </>
        );
    }

    return (
        <>
            <div >
                <ContactUs preloadedData={data.contactUs} />
            </div>
            <Body7 preloadedData={data.body7} />
            <Body9 preloadedData={data.body9} />
        </>
    );
};

const Contact = () => {
    return (
        <ContactDataProvider>
            <SEO pageName="contact" />
            <Navbar />
            <ContactPageContent />
            <Footer />
        </ContactDataProvider>
    );
};

export default Contact;
